module.exports = _.pull;